import request from '@/utils/request'

export function getTokenByTicket (params){
  return request ({
    url:'/auth/ticket/token',
    method: 'get',
    params
  })
}

export function getBusinessInfo (params){
  return request ({
    url:'/qr/jyqrcode/baseUser/getBusinessInfo',
    method: 'get',
    params
  })
}

export function logout (data){
  return request ({
    url:'/auth/login/logout',
    method: 'post',
    data:data
  })
}
// 获取账期时间
export function getAccountingDate (params){
  return request ({
    url:'/finance/common/books/accountingDate',
    method: 'get',
    params
  })
}

// 获取机构树列表
export function getOrgTree (params){
  return request ({
    url:'/system/org/tree',
    method: 'get',
    params
  })
}
// 获取机构账号信息
export function getBusinessInfoByOrgId (params){
  return request ({
    url:'/qr/jyqrcode/baseUser/getBusinessInfoByOrgId',
    method: 'get',
    params
  })
}

// 修改机构信息
export function updateOrgBusinessInfo (data){
  return request ({
    url:'/qr/jyqrcode/baseUser/updateOrgBusinessInfo',
    method: 'post',
    data:data
  })
}

//------------------门头沟岗位配置-------
// 新增岗位
export function addPost (data){
  return request ({
    url:'/qr/jyqrcode/job/addJobName',
    method: 'post',
    data:data
  })
}
// 获取岗位列表
export function getMtgPost (params){
  return request ({
    url:'/qr/jyqrcode/job/getJobNameList',
    method: 'get',
    params
  })
}

// 更新岗位
export function updatePost (data){
  return request ({
    url:'/qr/jyqrcode/job/updateJobName',
    method: 'post',
    data:data
  })
}